import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import languagedetector from "i18next-browser-languagedetector";

import transtionEN from "./Component/locale/en.json";
import transtionAR from "./Component/locale/ar.json";
const resources = {
  en: {
    translation: transtionEN,
  },
  ar: {
    translation: transtionAR,
  },
};

i18n
  .use(languagedetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: "en",
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
  });

export default i18n;
